import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ComponentsModule } from '@mastechnicaegroup/carelinelive-ui';
import { RefreshableResult } from '@mastechnicaegroup/carelinelive-cdk/rx';
import { ClientSingleResponse } from '@lib/api/models/client';
import { PersonNamePipe } from '@shared/pipes/person.pipes';
import { AppDatePipe } from '@shared/pipes/date.pipe';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { AccordionItemComponent } from '@shared/layout/accordion-item/accordion-item.component';

@Component({
    selector: 'app-client-details',
    imports: [
        AsyncPipe,
        ComponentsModule,
        PersonNamePipe,
        AppDatePipe,
        ErrorPanelComponent,
        AccordionItemComponent
    ],
    templateUrl: './client-general-information.component.html',
    standalone: true,
    styleUrl: './client-general-information.component.scss'
})
export class ClientGeneralInformationComponent {
    @Input() clientData: RefreshableResult<ClientSingleResponse> | undefined;
    @Output() editGeneralInformationEvent: EventEmitter<void> = new EventEmitter<void>();

    editGeneralInformation() {
        window.scrollTo(0, 0);
        this.editGeneralInformationEvent.emit();
    }
}
